import { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import ShowMore from '../helpers/ShowMore'
import Slider from 'react-slick'
import RoomPopup from '../popups/RoomPopup'

export default class RoomCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      roomInfo: {},
      isActive: {},
      roomPopupIsOpen: false,
    }
  }

  openRoomPopup = (roomInfo) => {
    this.setState({
      roomInfo,
      roomPopupIsOpen: true,
    })
  }

  closeRoomPopup = () => {
    this.setState({
      roomPopupIsOpen: false,
    })
  }

  render() {
    const settings = {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: false,
      dots: true,
      responsive: [
        { breakpoint: 768, settings: { arrows: false, slidesToShow: 1.2, slidesToScroll: 1, dots: true } },
        { breakpoint: 1025, settings: { arrows: false, slidesToShow: 2.5, slidesToScroll: 1, dots: true } },
      ],
    }
    if(!this.props.rooms || (this.props.rooms && !this.props.rooms.length)) {
      return ''
    }

    return (
      <div className='cabins-list'>
        { this.state.roomPopupIsOpen && <RoomPopup isOpen roomInfo={this.state.roomInfo} closeModal={this.closeRoomPopup} areaFormat={this.props.areaFormat} /> }
        <Slider className='slick-pt-custom' {...settings}>
          { this.props.rooms.map((room, index) => {
            return (
              <div className='cabin pointer' onClick={() => this.openRoomPopup(room)} key={room.title}>
                <div>
                  <div className='img'>
                    <span style={{ backgroundImage: `url(${room.images[0].url})` }} />
                    <div className='custom-paging'>1 / { room.images.length }</div>
                  </div>
                  <div className='information'>
                    <div className='info-head'>
                      <p className='title three-line-truncate'>{ room.title }</p>
                      <p className={`description ${!this.state.isActive[index] ? 'three-line-truncate' : ''}`}>{ room.description }</p>
                      <span className='more'><FormattedMessage id='read_more' defaultMessage='Read more' /></span>
                    </div>
                    <ul>
                      <li>
                        <strong><FormattedMessage id='size' defaultMessage='Size' />:&nbsp;</strong>
                        <span className='bold'>{ room.size }</span>
                      </li>
                      <li>
                        <strong><FormattedMessage id='beds' defaultMessage='Beds' />:&nbsp;</strong>
                        <span className='bold'>{ room.bedTypeTitle }</span>
                      </li>
                      <li>
                        <strong><FormattedMessage id='max_occupancy' defaultMessage='Max occupancy' />:&nbsp;</strong>
                        <span className='bold'>{ room.maxOccupancy }</span>
                      </li>
                      <li>
                        <strong><FormattedMessage id='shareable' defaultMessage='Shareable' />:&nbsp;</strong>
                        <span className='bold'>{ room.shareable }</span>
                      </li>
                      <li>
                        <strong><FormattedMessage id='private_bathroom' defaultMessage='Private bathroom' />:&nbsp;</strong>
                        <span className='bold'>{ room.privateBathroom }</span>
                      </li>
                      <li>
                        <strong><FormattedMessage id='air_conditioning' defaultMessage='Air Conditioning' />:&nbsp;</strong>
                        <span className='bold'>{ room.airConditition }</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )
          })
          }
        </Slider>
      </div>
    )
  }
}
